/**
 * Search Result Feedback Toggle Component
 * Icon button to open feedback modal for a specific message
 */

import { faMegaphone } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@hl/ui-components';
import React from 'react';

import { EMPTY_GUID } from '../../../../constants';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { useFeedbackContext } from './FeedbackProvider';

export interface SearchResultFeedbackToggleProps {
  messageId: string;
}

/**
 * SearchResultFeedbackToggle Component
 * Displays a megaphone icon button to share feedback on a specific message
 */
export const SearchResultFeedbackToggle: React.FC<
  SearchResultFeedbackToggleProps
> = ({ messageId }) => {
  
  const { feedbackButtonText } = useOcFabWidgetOptions();
  const { openFeedbackModal } = useFeedbackContext();

  // Don't render if messageId is empty
  if (!messageId || messageId === EMPTY_GUID) {
    return null;
  }

  return (
    <Icon
      icon={faMegaphone}
      onClick={() => openFeedbackModal(messageId)}
      title={feedbackButtonText}
    />
  );
};

export default SearchResultFeedbackToggle;

